import difficultyJson from "./difficulty.json";
import tileJson from "./tiles.json";
import tutorialJson from "./tutorial-levels.json";
import type { AuthoredLevel, DifficultyBand, TileBalance, TileType } from "../domain/types";

export const difficultyBands = difficultyJson as DifficultyBand[];
export const tileBalance = tileJson as Record<TileType, TileBalance>;
export const tutorialLevels = tutorialJson as AuthoredLevel[];

export function difficultyFor(level: number): DifficultyBand {
  const band = difficultyBands.find(item =>
    level >= item.minLevel && (item.maxLevel === null || level <= item.maxLevel));
  if (!band) throw new Error(`No difficulty band for level ${level}`);
  return band;
}
